export const MenuType = Object.freeze({
  SCREENING: 0,
  VISIT: 1,
  EOS: 2,
});

export const VisitType = Object.freeze({
  VISITING_DATA: 0, //방문별 자료
  LABORATORY: 1, //검사및 수행상태
  ADVERSE_EVENT: 2, //이상반응
  EVALUATION: 3, //이차 종양·임신 평가
  AFTER_TREATMENT: 4, //CAR T-세포 주입 후 치료
  AT_RELAPSE: 5, //CAR T-세포 치료 이후 재발시 환자 상태
  COMPLICATION_PROPHYLAXIS: 6, //CAR T-세포 합병증 예방요법
  SUBJECT_STATUS: 0,
  DIAGNOSIS_STATUS: 1,
  COMORBODITY: 2,
  PRE_CART_DISEASE_INFO: 3,
  RESSPONSE_EVAL: 7, //질병상태 및 반응평가
});
